/**
 * @generated SignedSource<<ce2c34f4872428c634fc08b19e03484c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type featureFlags_softwareReleasesVersionDetailIssueList_devOpsSummarisedEntities$data = {
  readonly providers: {
    readonly featureFlagProviders: ReadonlyArray<{
      readonly __typename: "DevOpsFeatureFlagProvider";
      readonly " $fragmentSpreads": FragmentRefs<"addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_devOpsFeatureFlagProviders">;
    } | null | undefined>;
  };
  readonly " $fragmentType": "featureFlags_softwareReleasesVersionDetailIssueList_devOpsSummarisedEntities";
};
export type featureFlags_softwareReleasesVersionDetailIssueList_devOpsSummarisedEntities$key = {
  readonly " $data"?: featureFlags_softwareReleasesVersionDetailIssueList_devOpsSummarisedEntities$data;
  readonly " $fragmentSpreads": FragmentRefs<"featureFlags_softwareReleasesVersionDetailIssueList_devOpsSummarisedEntities">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "featureFlags_softwareReleasesVersionDetailIssueList_devOpsSummarisedEntities",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "DevOpsProviders",
        "kind": "LinkedField",
        "name": "providers",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "concreteType": "DevOpsFeatureFlagProvider",
              "kind": "LinkedField",
              "name": "featureFlagProviders",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "__typename"
                },
                {
                  "kind": "FragmentSpread",
                  "name": "addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_devOpsFeatureFlagProviders"
                }
              ]
            },
            "action": "THROW",
            "path": "providers.featureFlagProviders"
          }
        ]
      },
      "action": "THROW",
      "path": "providers"
    }
  ],
  "type": "DevOpsSummarisedEntities"
};

(node as any).hash = "6396e923543528812899038e05950d31";

export default node;
